const config = {
  apiURL: "https://apimain.payeasy88-xtb.com",
  apiURLscb: "https://sbc.promplayvip.com",
  apiURLManual: "https://easy.krungthaipay.com",
  apiURLnof: "http://localhost:8080",
  webHookUrl_wallet: "https://tmn.payeasy88-xtb.com/hook/",
  apiURLback: process.env.REACT_APP_API_URL,
  apiURLfont: process.env.REACT_APP_API_URL,
  reCAPTCHA: process.env.reCAPTCHA,
  network: window.location.pathname,
  web_name: "PayEasy",
  web_name_short: "PAYEASY",
  merchant: "PayEasy",
  updateDate: "2025-09-30",
  lastVersion: "4.2.1",
  version: "4.2.0",
  paginationPerPage: 10,
  audio: `https://tiengdong.com/wp-content/uploads/Nhac-chuong-thong-bao-iphone-12-www_tiengdong_com.mp3?_=1`,
  totalSpriteColoumn: 8,
  spriteImageWidth: 1370,
  spriteImageHeight: 200,
  url_scb: process.env.REACT_APP_API_URLSCB,
  bucketBaseUrl: "https://battlelabdemo.s3.ap-southeast-1.amazonaws.com",
  TOKEN: "8457346777:AAFE9Ysh2a28aw7Y0miu__poI2Fu5SGdMI4",
  CHAT_ID: "-5143672878", // PROD
  // SUPPORT
  TOKEN_TELE_SUPPORT: "8638265763:AAFiUXkTIi7U4TsDtDB2AEZkfghtJPdQNhc",
  CHAT_ID_TELE_SUPPORT: "-1004470757277", // PROD-SUPPORT

  TOKEN_ANNOUNCE: "8782021426:AAETuOVrZNLj_Eb52D9zgkXMpqHTlCEzfbI",
};

if (process.env.REACT_APP_ENV === "staging") {
  config.apiURL = "https://apidemo.payeasy88-xtb.info";
  config.CHAT_ID = "-1003973720335"; // STG
  config.CHAT_ID_TELE_SUPPORT = "-1003973720335"; // STG
  config.web_name_short = "PAYEASY (STG)";
  config.web_name = `PayEasy (STG)`;
  config.TOKEN_ANNOUNCE = "7983412769:AAHaA2e60QZdvwag_owjU9HO8UfNqsOIrT4";
}

export default config;
